import Vue from 'vue'
import FreshVueForms from '@freshsolutions/fresh-vue-forms'
import i18n from './i18n'

Vue.use(FreshVueForms, {
  i18n: i18n
})
